// src/pages/markets/board/api/boardKeys.ts

import { GATED_FIELDS, type BoardFilters } from './boardTypes';

// Explicit field order, not JSON.stringify over the object: key order in the
// object would leak into the cache key and split identical queries.
export function filterSignature(f: BoardFilters): string {
    const list = (xs: string[] | null | undefined) =>
        xs === null || xs === undefined ? '*' : [...xs].sort().join('|');
    const base = [
        f.group ?? '',
        f.sortBy,
        f.sortDir,
        list(f.eventsInclude),
        list(f.eventsExclude),
        list(f.tagsInclude),
        list(f.tagsExclude),
        f.tagMatch,
    ];
    // Every gated field, or two different jump windows collide on one entry.
    for (const field of GATED_FIELDS) {
        const v = f[field];
        base.push(v === undefined || v === null ? '' : String(v));
    }
    return base.join('~');
}

export const boardKeys = {
    all: ['board'] as const,
    schema: () => ['board', 'schema'] as const,
    events: (column: string, signature: string) =>
        ['board', 'events', column, signature] as const,
    rank: (column: string, signature: string, limit: number) =>
        ['board', 'rank', column, signature, limit] as const,
    event: (eventId: string) => ['board', 'event', eventId] as const,
    score: (eventId: string, group: string) => ['board', 'score', eventId, group] as const,
    series: (marketIdsKey: string, window: string, resolution: string | null) =>
        ['board', 'series', marketIdsKey, window, resolution ?? ''] as const,
    activity: (eventIdsKey: string, signature: string) =>
        ['board', 'activity', eventIdsKey, signature] as const,
    traders: (marketId: string, group: string) =>
        ['board', 'traders', marketId, group] as const,
    eventOutcomes: (eventId: string) => ['board', 'event-outcomes', eventId] as const,
    groupStats: (group: string, signature: string, window: string) =>
        ['board', 'group-stats', group, signature, window] as const,
};

export function idsKey(ids: readonly string[]): string {
    return [...ids].sort().join(',');
}